export function initSidebarFocus(){
    document.querySelectorAll<HTMLLIElement>('.services-item').forEach(item => {
        item.addEventListener('mouseenter', () => {
            // предыдущий предыдущий элемент
            const prevPrev = item.previousElementSibling?.previousElementSibling as HTMLLIElement | null;
            const link = prevPrev?.querySelector<HTMLAnchorElement>('.services-link');
            link?.classList.add('prev-hover');
        });

        item.addEventListener('mouseleave', () => {
            const prevPrev = item.previousElementSibling?.previousElementSibling as HTMLLIElement | null;
            const link = prevPrev?.querySelector<HTMLAnchorElement>('.services-link');
            link?.classList.remove('prev-hover');
        });
    });
}